const themes = {
    primary: {
        main: '#F39189',
        sub: '#BB8082',
    },
    secondary: {
        main: '#046582',
        sub: '#6E7582',
    },
    background: {
        main: '#3F3351',
        sub: '#1F1D36',
        contrast : '#E8EAE6',
    }
}

export {themes}